export enum EntityTypeEnum {
  TASK = "task",
  BACKLOG_ITEM = "backlog_item",
  GUESSTIMATION_ITEM = "guesstm_item",
  OBJECTIVE = "objective",
  INITIATIVE = "initiative",
  BOARD = "board",
  PROJECT = "project",
}
